module.exports = __webpack_public_path__ + "static/media/signup-shopfront.c2b28ab0.png";